import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill-new';
import { useSafeClose } from '../../../hooks/useSafeClose';
import 'react-quill-new/dist/quill.snow.css';
import './ExportFreeTextModal.css';

const modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['clean']
    ],
};

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet'
];

export default function ExportFreeTextModal({ isOpen, onClose, onSave, initialHtml }) {
    const [editorHtml, setEditorHtml] = useState(initialHtml || '');
    const { overlayRef, onMouseDown, onMouseUp } = useSafeClose(onClose);

    useEffect(() => {
        if (isOpen) {
            setEditorHtml(initialHtml || '');
        }
    }, [isOpen, initialHtml]);

    if (!isOpen) return null;

    const handleSave = () => {
        onSave(editorHtml);
        onClose();
    };

    const handleReset = () => {
        onSave('');
        onClose();
    };

    const hasContent = editorHtml && editorHtml.replace(/<[^>]*>/g, '').trim().length > 0;

    return (
        <div
            className="modal-overlay"
            ref={overlayRef}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            style={{ zIndex: 10001 }}
        >
            <div className="modal-content free-text-modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Freitext hinzufügen</h2>
                    <button onClick={onClose} className="btn-close-text">&times;</button>
                </div>

                <div className="free-text-editor-container">
                    <ReactQuill
                        theme="snow"
                        value={editorHtml}
                        onChange={setEditorHtml}
                        modules={modules}
                        formats={formats}
                        className="custom-quill-editor"
                    />
                </div>

                <div className="modal-actions" style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    {hasContent && (
                        <button onClick={handleReset} className="btn-modal btn-reset" style={{ marginRight: 'auto' }}>Zurücksetzen</button>
                    )}
                    <button onClick={onClose} className="btn-modal btn-cancel">Abbrechen</button>
                    <button onClick={handleSave} className="btn-modal btn-save">Speichern</button>
                </div>
            </div>
        </div>
    );
}
